import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const CustomField = lazy(() => import("@/pages/CustomField/CustomField"));

const CustomFieldRoute: RouteConfig = {
    path: "customfield",
    element: <CustomField />,
    pageName: "Custom Field",
    sidebar: { show: true, icon: "" },
    permission: ["CustomFieldManagement"],
}

export default CustomFieldRoute;